/* eslint-disable import/prefer-default-export */

export const COLANDER_GROUPS = {
    NEW: 'hub_new',
    DEFAULT: 'hub_default',
    COMMERCIAL: 'hub_commercial',
};

export const COLANDER_SLUGS = {
    USED: 'used',
};
